import { createStyles, makeStyles } from '@material-ui/styles'

const styles = () => createStyles({
  dateFilterWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%'
  },

  label: {
    paddingBottom: '2px',
    fontSize: '12px',
  },

  datePicker: {
    width: '100%',
    padding: '7px 15px',
    border: '1px solid rgba(110, 110, 110, 0.5)',
    borderRadius: '8px',
  },
})

export default makeStyles(styles)
